import http from '../../../../libs/http'

export default (payload = {
  name: '',
  factor: true,
  value: 0
}) => http.post(`${process.env.VUE_APP_MICROSERVICE_API_SHOPS}/presentation`, payload)
